interface FooterProps {
  onNavigate: (page: string, data?: any) => void;
}

export default function Footer({ onNavigate }: FooterProps) {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo.png" alt="ScribeHaven" className="w-7 h-7 rounded-full" />
              <span className="text-lg font-bold bg-gradient-to-r from-ink-400 to-ink-600 bg-clip-text text-transparent">
                ScribeHaven
              </span>
            </div>
            <p className="text-gray-500 text-sm">
              A platform for readers and writers to discover, create, and share serialized fiction.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => onNavigate('home')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('discover')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Discover
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('leaderboard')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Leaderboard
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('contest')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Contests
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('blog')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Blog
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Create</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => onNavigate('dashboard')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Author Dashboard
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('register')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Start Writing
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => onNavigate('terms')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Terms of Service
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('privacy')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('content-guidelines')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Content Guidelines
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('community-guidelines')} className="text-gray-500 hover:text-gray-300 text-sm transition-colors">
                  Community Guidelines
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            &copy; 2026 ScribeHaven. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
